export enum ProductNameEnum {
  AscendQuest = 'AscendQuest',
  AscendArchives = 'AscendArchives',
  AscendVerifications = 'AscendVerifications',
  AscendUSAA = 'AscendUSAA',
}

export const ProductNames = Object.values(ProductNameEnum);

export enum PackageNameEnum {
  WebQuest = 'WebQuest',
  FrontEndProcessing = 'FrontEndProcessing',
}
